import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ch_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem('ch_token');
    if (!t) { setLoading(false); return; }
    api.get('/auth/me').then((r) => {
      setUser(r.data);
      localStorage.setItem('ch_user', JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem('ch_token');
      localStorage.removeItem('ch_user');
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('ch_token', res.data.access_token);
    localStorage.setItem('ch_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('ch_token');
    localStorage.removeItem('ch_user');
    setUser(null);
  }, []);

  const can = useCallback((perm) => {
    if (!user) return false;
    const perms = user.permissions || [];
    return perms.includes('all') || perms.includes(perm);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
